import { Action } from '@ngrx/store';
import { AgreementAdditionOrder } from '@model';

export enum AgreementActionTypes {
    CreateAdditionAgreement = '[Contracts] Create Addition Agreement',
    CreateAdditionAgreementSuccess = '[Contracts] Create Addition Agreement success',
    CreateAdditionAgreementFail = '[Contracts] Create Addition Agreement fail',
    AgreementLinkLoad = '[Contracts] Agreement Link Load',
    AgreementLinkLoadSuccess = '[Contracts] Agreement Link Load Success',
    AgreementLinkLoadFail = '[Contracts] Agreement Link Load Fail',
    IsAdditionAgreementCreated = '[AdditionAgreement] Created',
    IsAdditionAgreementCreatedSuccess = '[AdditionAgreement] Created success',
    IsAdditionAgreementCreatedFail = '[AdditionAgreement] Created fail',
    ClearCreateAdditionAgreementState = '[AdditionAgreement]  Clear create state'
}

// Agreement Addition Order
export class CreateAdditionAgreement implements Action{
    readonly type = AgreementActionTypes.CreateAdditionAgreement;
    constructor(public payload: AgreementAdditionOrder){}
  }
  export class CreateAdditionAgreementSuccess implements Action{
    readonly type = AgreementActionTypes.CreateAdditionAgreementSuccess;
    constructor(public payload: number){}
  }
  
  export class CreateAdditionAgreementFail implements Action{
    readonly type = AgreementActionTypes.CreateAdditionAgreementFail;
    constructor(public payload: any){}
  }

  export class AgreementLinkLoad implements Action{
    readonly type = AgreementActionTypes.AgreementLinkLoad;
    constructor(public agreementId: number){}
}

export class AgreementLinkLoadSuccess implements Action{
    readonly type = AgreementActionTypes.AgreementLinkLoadSuccess;
    constructor(public payload: string){}
}

export class AgreementLinkLoadFail implements Action{
    readonly type = AgreementActionTypes.AgreementLinkLoadFail;
    constructor(public payload: any){}
}

export class IsAdditionAgreementCreated implements Action {
  readonly type = AgreementActionTypes.IsAdditionAgreementCreated;
  constructor(public payload: AgreementAdditionOrder) {}
}
export class IsAdditionAgreementCreatedSuccess implements Action {
  readonly type = AgreementActionTypes.IsAdditionAgreementCreatedSuccess;
  constructor(public payload: boolean) {}
}
export class IsAdditionAgreementCreatedFail implements Action {
  readonly type = AgreementActionTypes.IsAdditionAgreementCreatedFail;
  constructor(public payload: any) {}
}
export class ClearCreateAdditionAgreementState implements Action {
  readonly type = AgreementActionTypes.ClearCreateAdditionAgreementState;
  constructor() {}
}
  
export type AgreementActions =
    CreateAdditionAgreement
    | CreateAdditionAgreementSuccess
    | CreateAdditionAgreementFail
    | AgreementLinkLoad
    | AgreementLinkLoadSuccess
    | AgreementLinkLoadFail
    | IsAdditionAgreementCreated
    | IsAdditionAgreementCreatedSuccess
    | IsAdditionAgreementCreatedFail
    | ClearCreateAdditionAgreementState;

  